var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}.b{fill:#3c3f45;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.474)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24,
    transform: "translate(0 -0.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-341.5-2388.474a2.5,2.5,0,0,1-2.5-2.5v-4a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v4a1.5,1.5,0,0,0,1.5,1.5h14a1.5,1.5,0,0,0,1.5-1.5v-4a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v4a2.5,2.5,0,0,1-2.5,2.5Zm7-6h-.091l-.008,0h0l-.009,0h0a.491.491,0,0,1-.185-.086h0l-.007-.005a.52.52,0,0,1-.056-.052l-4.99-4.99a.5.5,0,0,1,0-.707.5.5,0,0,1,.707,0l4.146,4.147v-10.794a.5.5,0,0,1,.5-.5.5.5,0,0,1,.5.5v10.793l4.146-4.146a.5.5,0,0,1,.707,0,.5.5,0,0,1,0,.707l-4.992,4.991a.49.49,0,0,1-.036.034.494.494,0,0,1-.262.117h-.065Z",
    transform: "translate(346.5 2409.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.da21443b.svg";
export { ForwardRef as ReactComponent };